import React, { useState } from 'react';

import { Box, ClickAwayListener, Popper, MenuList, MenuItem, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

import { TYPE_OPTIONS_ENUM, TYPE_OPTIONS } from '../../constants/observations';
import { getTypeLabel } from '../../utils/observations';

const useStyles = makeStyles(() => ({
  callBackChip: {
    backgroundColor: 'white',
    border: '1px solid #FF8F00',
    color: '#FF8F00',
  },
  chip: {
    '&:hover': {
      opacity: 0.8,
    },
    alignItems: 'center',
    borderRadius: 100,
    cursor: 'pointer',
    display: 'flex',
    fontSize: 12,
    fontWeight: 'bold',
    gap: 4,
    height: 22,
    padding: '0 8px',
    transition: 'all 0.2s ease',
  },
  dropdownIcon: {
    fontSize: 16,
    transition: 'transform 0.2s ease',
  },
  dropdownIconOpen: {
    transform: 'rotate(180deg)',
  },
  menuItem: {
    borderRadius: 0,
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 4,
    minHeight: 32,
    padding: '6px 12px',
  },
  menuPaper: {
    boxShadow: '1px 1px 10px 0px #0000001A',
    marginTop: 4,
    minWidth: 100,
  },
  routineChip: {
    backgroundColor: '#c3edff',
    border: '1px solid #0789fd',
    color: '#0789fd',
  },
  statChip: {
    backgroundColor: '#FBECEC',
    border: '1px solid red',
    color: 'red',
  },
  urgentChip: {
    backgroundColor: '#FFEBCD',
    border: '1px solid #E2A74F',
    color: '#E2A74F',
  },
}));

const TypeChipDropdown = ({ type, onChange, disabled = false }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  if (!type) return null;

  const getTypeChipClass = (typeValue) => {
    switch (typeValue?.toLowerCase()) {
      case TYPE_OPTIONS_ENUM.CALL_BACK:
        return `${classes.chip} ${classes.callBackChip}`;
      case TYPE_OPTIONS_ENUM.STAT:
        return `${classes.chip} ${classes.statChip}`;
      case TYPE_OPTIONS_ENUM.URGENT:
        return `${classes.chip} ${classes.urgentChip}`;
      case TYPE_OPTIONS_ENUM.ROUTINE:
      default:
        return `${classes.chip} ${classes.routineChip}`;
    }
  };

  const handleClick = (event) => {
    if (disabled) return;
    setAnchorEl(event.currentTarget);
    setIsOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };

  const handleTypeChange = (newType) => {
    if (onChange && newType !== type) {
      onChange(newType);
    }
    handleClose();
  };

  return (
    <Box>
      <Box className={getTypeChipClass(type)} onClick={handleClick} style={{ cursor: disabled ? 'default' : 'pointer' }}>
        {getTypeLabel(type)}
        {!disabled && <ExpandMore className={`${classes.dropdownIcon} ${isOpen ? classes.dropdownIconOpen : ''}`} />}
      </Box>

      {!disabled && (
        <Popper open={isOpen} anchorEl={anchorEl} placement="bottom-start" disablePortal>
          <ClickAwayListener onClickAway={handleClose}>
            <Paper className={classes.menuPaper}>
              <MenuList>
                {TYPE_OPTIONS.map((option) => (
                  <MenuItem key={option.value} className={classes.menuItem} onClick={() => handleTypeChange(option.value)} selected={option.value === type}>
                    {option.label}
                  </MenuItem>
                ))}
              </MenuList>
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}
    </Box>
  );
};

export default TypeChipDropdown;
